import React, { useState } from "react";
import { useLocation } from "react-router-dom";

// Creates a context for managing the state in the workflow
const WorkflowContext = React.createContext(null);
// Define the main component
export default function BCMSWorkflow(props) {
    // Retrieve the values passed from the properties
    // Set default values if the property has not been passed
    const step = props.step ? parseInt(props.step) : 0;
    const steps = props.steps ?? [];
    const value = props.value ?? {};
    const constructor = props.constructor ?? undefined;
    // Create a new state for managing the step and the value of the workflow
    const [ state, setState ] = useState({ step, value });
    const controller = {
        state: state.value,
        // goStep :: (INTEGER, *) -> VOID
        // Updates the step and value in the state
        goStep: (step, value) => setState({ step, value: value ?? state.value }),

        // nextStep :: (*) -> VOID
        // Increments the step and updates the value in the state
        nextStep: value => controller.goStep(state.step + 1, value),

        // prevStep :: (*) -> VOID
        // Decreases the step and updates the value in the state
        prevStep: value => controller.goStep(state.step - 1, value),

        // update :: (*) -> VOID
        // Updates the value in the state
        update: value => setState({ ...state, value })
    };

    // Start V2.7.2 Backward Compatibility
        // Document listener to set state for a workflow
        document.addEventListener("force-workflow-state", evt => {
            const update = () => controller.update(constructor instanceof Function ? constructor(evt.detail.value) : evt.detail.value);
            if(evt.detail.workflowName === undefined || evt.detail.workflowName === name) { update(); }
        });
        
        // Document listener to set step for a workflow
        document.addEventListener("force-workflow-step", evt => {
            const update = () => controller.goStep(evt.detail.value, state.value);
            if(evt.detail.workflowName === undefined || evt.detail.workflowName === name) { update(); }
        });
    // End V2.7.2 Backward Compatibility

    // Retrieves the current component based on the step in the state
    const Component = steps[state.step];
    const { data, ui } = state.value;

    return (
        <WorkflowContext.Provider value={ controller }>
            { /** V2.7.2 Backward Compatibility */ }
            { /** Newer versions should pass the initalization function instead of the actual component */ }
            { steps[state.step] instanceof Function ? <Component data={ data } ui={ ui } /> : steps[state.step] }
        </WorkflowContext.Provider>
    );
}

// Hook to access the state of the workflow
export const useBCMSWorkflow = () => React.useContext(WorkflowContext);

// Start V2.7.2 Backward Compatibility
    // Go through the steps passed and return the index of the route
    export const useBCMSWorkflowStep = steps => {
        for(const [route, component] of Object.entries(steps)) {
            if(route == useLocation().pathname) {
                return Object.keys(steps).indexOf(route);
            }
        }

        return undefined;
    };
// End V2.7.2 Backward Compatibility